import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AccountService } from 'src/app/services/account.service';
import { OtherService } from 'src/app/services/other.service';
import { PersianNumberService } from 'ngx-persian';
import Swal from 'sweetalert2';
declare var bootstrap: any;
declare let $: any;
@Component({
  selector: 'app-all-trip',
  templateUrl: './all-trip.component.html',
  styleUrls: ['./all-trip.component.css'],
})

export class AllTripComponent implements OnInit {
  list_Trip: any[] = [];
  driverEvidence: any[] = [];
  modalMode: number = 1;
  Info: any;
  postDetail: any;
  mainImg: any;
  strPassenger_CancelReason: any;
  currentRating: any = '';
  showCustom_Map: boolean = false;

  mdl_Payment: FormGroup = this.formBuilder.group({
    iTaxiLon_User: this.otherService.getLocalStorage().Id,
    strSession: this.otherService.getLocalStorage().session,
    iTaxiLon_Trip: new FormControl(''),
    strSuccessURL: new FormControl(''),
    tiAppType: new FormControl('1'),
  })

  mdl_Map: FormGroup = this.formBuilder.group({

    strAddress: new FormControl(''),

    fLon: new FormControl(''),

    fLat: new FormControl(''),

    strSource: new FormControl(''),

  });

  constructor(
    private accountService: AccountService,
    private router: Router,
    private otherService: OtherService,
    private toastr: ToastrService,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private persianNumber: PersianNumberService
  ) { }

  ngOnInit(): void {

    this.Info = this.otherService.getLocalStorage();

    this.getTrips();

  }

  getTrips() {
    var model = {
      iTaxiLon_User: this.Info.Id,
      strSession: this.Info.session,
    };
    this.accountService
      .TaxiLon_Trip_Passenger_List(model)
      .subscribe((data: any) => {
        let res = JSON.parse(data.toString());
        this.list_Trip = res;

      });
  }

  openDetails(item) {
    this.goBack(1)
    var myModal = new bootstrap.Modal(document.getElementById('details'), {});
    myModal.show();
    this.postDetail = item;
  }

  openDetailsimg(item) {

    var model = {
      iTaxiLon_User: this.Info.Id,
      strSession: this.Info.session,
      iEvidenceDriver: item.iEvidenceDriver
    };
    this.accountService.TaxiLon_EvidenceDriver_Info4Passenger(model).subscribe((data: any) => {
      let res = JSON.parse(data.toString());
      this.mainImg = res[0]?.strImage

      var myModal = new bootstrap.Modal(document.getElementById('detailsimg'), {});
      myModal.show();
    });

  }

  openCancelTrip(e) {
    this.modalMode = e;
    if (e == 4) {
      this.getEvidenceDriver()
    }
  }

  getEvidenceDriver() {

    var model = {

      iTaxiLon_User: this.Info.Id,

      strSession: this.Info.session,

      iTaxiLon_Trip: this.postDetail?.iTaxiLon_Trip,

    };

    this.accountService.TaxiLon_EvidenceDriver_List4Passenger(model).subscribe((data: any) => {

      let res = JSON.parse(data.toString());

      this.driverEvidence = res

    });

  }

  cancelTrip(e) {

    if (!this.strPassenger_CancelReason || this.strPassenger_CancelReason.trim() == '') return this.accountService.toastSwal('error', ' دلیل لغو سفر را تایپ کنید');

    Swal.fire({

      title: 'آیا از لغو این سفر اطمینان دارید؟',

      icon: 'warning',

      showCancelButton: true,

      showConfirmButton: true,

      reverseButtons: true,

      confirmButtonColor: '#10b981',

      confirmButtonText: 'تایید',

      cancelButtonText: 'لغو',

    }).then((result) => {

      if (result.isConfirmed) {

        var model = {

          iTaxiLon_User: this.Info.Id,

          strSession: this.Info.session,

          iTaxiLon_Trip: e,

          strPassenger_CancelReason: this.strPassenger_CancelReason,

        };

        this.accountService.TaxiLon_Trip_Passenger_Cancel(model).subscribe((response) => {

          let res = JSON.stringify(response);

          let resPars = JSON.parse(res);

          if (resPars.iResult == 0 || resPars.bError) {

            Swal.fire({

              title: 'خطا',

              icon: 'error',

              showCancelButton: true,

              showConfirmButton: false,

              cancelButtonText: 'تایید',

            });

          }

          else {

            Swal.fire({

              title: 'با موفقیت لغو شد',

              icon: 'success',

              showCancelButton: true,

              showConfirmButton: false,

              cancelButtonText: 'تایید',

            });

            window.location.reload();

          }

        });

      }

    });

  }

  setTripRate(e) {

    var model = {

      iTaxiLon_User: this.Info.Id,

      strSession: this.Info.session,

      iTaxiLon_Trip: e,

      tiDriverPoints: this.currentRating.rating,

      strPassengerOpinion: this.currentRating.strPassengerOpinion,

    };

    if (model.tiDriverPoints == 0 || model.tiDriverPoints == undefined) return this.accountService.toastSwal('error', 'میزان رضایت خود را مشخص کنید');

    Swal.fire({
      title: 'آیا از ثبت این امتیاز اطمینان دارید؟',
      icon: 'warning',
      showCancelButton: true,
      showConfirmButton: true,
      reverseButtons: true,
      confirmButtonColor: '#10b981',
      confirmButtonText: 'تایید',
      cancelButtonText: 'لغو',
    }).then((result) => {
      if (result.isConfirmed) {



        this.accountService.TaxiLon_Trip_Passenger_SetPoints(model).subscribe((response) => {
          let res = JSON.stringify(response);
          let resPars = JSON.parse(res);


          if (resPars.iResult == 0) {
            Swal.fire({
              title: 'خطا',
              icon: 'error',
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: 'تایید',
            });
          } else {
            Swal.fire({
              title: 'با موفقیت ثبت شد',
              icon: 'success',
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: 'تایید',
            });
            window.location.reload();
          }
        });
      }
    });

  }

  goBack(e) {
    this.modalMode = 1;
  }

  onRatingChange(newRating: number): void {
    this.currentRating = newRating;
  }

  payInvoice() {

    this.mdl_Payment.patchValue({
      iTaxiLon_Trip: this.postDetail.iTaxiLon_Trip,
      // strSuccessURL: `${window.location.origin}/taxilon/payment/ZarinpalCallback/prepayment`
    })

    this.accountService.taxiLon_PayInvoice(this.mdl_Payment.value).subscribe((data: any) => {
      let res = JSON.parse(data.toString());
      if (res.iResult == 0) {
        return this.accountService.toastSwal('error', res.strError);
      }

      window.open(res.strURL, '_self')

    });

  }

  printInvoice() {

    window.print();

  }

  showMap(location) {

    this.mdl_Map.patchValue({

      strAddress: location[2],

      fLon: location[1],

      fLat: location[0],

    });

    this.showCustom_Map = true;

  }

}
